import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FinancialPeriodDataDTO } from 'src/app/core/models/system/financial/financialperioddata.dto';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-dropdown-date-month',
  templateUrl: './dropdown-date-month.component.html',
  styleUrls: ['./dropdown-date-month.component.scss']
})

export class DropdownDateMonthComponent implements AfterViewInit, OnInit {

  @Input() initialDateMonthId  : number  | undefined;
  
  @Output() selectOnChangeEvent: EventEmitter<number> = new EventEmitter<number>();

  private dateMonthIdData!: FinancialPeriodDataDTO[];

  public addOrEditForm!: UntypedFormGroup;
  
  constructor(
    private exceptionsService: ExceptionsService,
    private formBuilder      : FormBuilder
  ) { }

  ngOnInit(): void {
    try {
      let dateMonthId=this.initialDateMonthId==undefined ? 0 : this.initialDateMonthId;

      this.addOrEditForm = this.formBuilder.group({
        dateMonthID: [dateMonthId, []]
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  ngAfterViewInit(){
    try {
      this.selectOnChange(undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getDropdownDataObjectArray() {
    try {
      return this.dateMonthIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  public selectOnChange(event: Event | undefined) {
    try {
      let dateMonthID=this.addOrEditForm.controls["dateMonthID"].value;

      if (isNaN(dateMonthID) || dateMonthID=="") {
        dateMonthID=-1;
      }

      this.selectOnChangeEvent.emit(dateMonthID);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
}
